export default __webpack_public_path__ + "static/media/international.cfc5b156.svg";